import { useState, useEffect } from 'react'

const eventName = 'captchaLoad'

function useCaptchaLoadTracker() {
  const [isLoaded, setIsLoaded] = useState(window.mtcaptcha)

  function trackLoad() {
    setIsLoaded(window.mtcaptcha)
  }

  useEffect(() => {
    window.addEventListener(eventName, trackLoad)

    return () => {
      window.removeEventListener(eventName, trackLoad)
    }
  }, [])

  return isLoaded
}

export default useCaptchaLoadTracker
